export const PRODUCT_URL = "https://api.chec.io/v1/products/";

export const PRODUCT_API = process.env.REACT_APP_PRODUCT_API;

export const PUBLIC_API_KEY = process.env.REACT_APP_PRODUCTS_API;
